import { Form, Icon, Input, Radio } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReactIntlTelInput from 'react-intl-tel-input-v2';
import { intlTelOpts } from '../data';

export default function PhoneScreen({
	form,
	formNumber,
	countryValue,
	onCountryChange,
	onFieldChange,
}) {
	const { getFieldDecorator } = form;
	return (
		<>
			<div style={{ fontSize: 22 }}>
				<FormattedMessage id="select_country" />
			</div>
			<Form.Item>
				{getFieldDecorator('country', {
					rules: [
						{
							required: false,
							message: <FormattedMessage id="form_msg_country" />,
						},
					],
				})(
					<FormattedMessage id="form_country">
						{(msg) => (
							<>
								<ReactIntlTelInput
									inputProps={{
										placeholder: msg,
										style: {
											width: '100%',
											borderColor: 'rgba(217, 217, 217, 0.3)',
											borderRadius: 6,
											borderStyle: 'groove',
										},
									}}
									intlTelOpts={intlTelOpts}
									value={countryValue}
									onChange={onCountryChange}
								/>
							</>
						)}
					</FormattedMessage>,
				)}
			</Form.Item>
			<div style={{ fontSize: 22 }}>
				<FormattedMessage id="type_number" />
			</div>
			<Form.Item>
				{getFieldDecorator('phone_number', {
					rules: [
						{
							required: false,
							message: <FormattedMessage id="form_msg_phone_number" />,
						},
					],
				})(
					<FormattedMessage id="phone_number">
						{(msg) => (
							<Input
								prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />}
								placeholder={msg}
								defaultValue={formNumber.number}
								value={formNumber.number}
								onChange={(e) =>
									onFieldChange('number', parseInt(e.target.value.replace(/\D+/g, '')) || null)
								}
							/>
						)}
					</FormattedMessage>,
				)}
			</Form.Item>
			<FormattedMessage id="example_number" />
			<div style={{ fontSize: 22 }}>
				<FormattedMessage id="form_is_national" />
			</div>
			<Form.Item style={{ marginBottom: 0 }}>
				{getFieldDecorator('is_national', {
					rules: [
						{
							required: false,
							message: <FormattedMessage id="form_msg_is_national" />,
						},
					],
				})(
					<>
						<div style={{ paddingLeft: 10 }}>
							<Radio.Group
								defaultValue={'0'}
								buttonStyle="solid"
								onChange={(e) => onFieldChange('remove_cc', e.target.value)}
								style={{ width: '100%' }}
							>
								<Radio.Button value="1">
									<FormattedMessage id="national" />
								</Radio.Button>
								<Radio.Button value="0">
									<FormattedMessage id="not_national" />
								</Radio.Button>
							</Radio.Group>
						</div>
					</>,
				)}
			</Form.Item>
		</>
	);
}
